import { Matrix4, Quaternion, Vector3 } from 'three';

const _scale = new Vector3(1, 1, 1);
const _vec = new Vector3();
const _quater = new Quaternion();

export class Extrinsic {
  static LENGTH = 7;

  static IDENTITY = [0, 0, 0, 0, 0, 0, 1];

  /**
   * 判断两个车姿数据相等
   * @param a
   * @param b
   * @param threshold 相等阈值，各维差值均小于等于该值则认为相等
   * @returns
   */
  static equals(a: number[], b: number[], threshold = 0): boolean {
    if (a.length === b.length && a.length === Extrinsic.LENGTH) {
      return a.every((value, index) => Math.abs(value - b[index]) <= threshold);
    }
    return false;
  }

  static fromMatrix4(mat: Matrix4, result = new Array(7)): number[] {
    mat.decompose(_vec, _quater, _scale);
    _vec.toArray(result);
    _quater.toArray(result, 3);
    return result;
  }

  static toMatrix4(pose: number[], result = new Matrix4()): Matrix4 {
    return result.compose(_vec.fromArray(pose), _quater.fromArray(pose, 3), _scale);
  }
}
